var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page",
      staticStyle: {
        margin: "0 auto",
        width: "980px",
        border: "0px solid #E8E8EC",
      },
      attrs: { id: "printPage" },
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("儿童多动症筛查")]),
      _c(
        "table",
        {
          staticClass: "container",
          staticStyle: { border: "none", "text-align": "left" },
          attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
        },
        [
          _c("tbody", [
            _c(
              "tr",
              { staticStyle: { "line-height": "25px", border: "none" } },
              [
                _c("td", { staticStyle: { border: "none" } }, [
                  _vm._v("测评机构： " + _vm._s(_vm.form.institution_name)),
                ]),
              ]
            ),
            _c(
              "tr",
              { staticStyle: { "line-height": "25px", border: "none" } },
              [
                _c("td", { staticStyle: { border: "none" } }, [
                  _vm._v("测评时间： " + _vm._s(_vm.form.medicalDate)),
                ]),
              ]
            ),
            _vm._m(0),
          ]),
        ]
      ),
      _vm._m(1),
      _c(
        "table",
        {
          staticClass: "container",
          staticStyle: { border: "none", "text-align": "left" },
          attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
        },
        [
          _c("tbody", [
            _c(
              "tr",
              { staticStyle: { "line-height": "25px", border: "none" } },
              [
                _c(
                  "td",
                  { staticStyle: { border: "none" }, attrs: { colspan: "1" } },
                  [_vm._v("姓名： ")]
                ),
                _c(
                  "td",
                  {
                    staticStyle: { border: "none", "font-weight": "600" },
                    attrs: { colspan: "7" },
                  },
                  [_vm._v(_vm._s(_vm.form.name))]
                ),
              ]
            ),
            _c(
              "tr",
              { staticStyle: { "line-height": "25px", border: "none" } },
              [
                _c(
                  "td",
                  { staticStyle: { border: "none" }, attrs: { colspan: "1" } },
                  [_vm._v("性别： ")]
                ),
                _c(
                  "td",
                  {
                    staticStyle: { border: "none", "font-weight": "600" },
                    attrs: { colspan: "7" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.form.gender === 1
                          ? "男"
                          : _vm.form.gender === 2
                          ? "女"
                          : ""
                      )
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "tr",
              { staticStyle: { "line-height": "25px", border: "none" } },
              [
                _c(
                  "td",
                  { staticStyle: { border: "none" }, attrs: { colspan: "1" } },
                  [_vm._v("年龄： ")]
                ),
                _c(
                  "td",
                  {
                    staticStyle: { border: "none", "font-weight": "600" },
                    attrs: { colspan: "7" },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        (_vm.form.age + "").length > 0
                          ? _vm.form.age + "岁"
                          : ""
                      )
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "tr",
              { staticStyle: { "line-height": "25px", border: "none" } },
              [
                _c(
                  "td",
                  { staticStyle: { border: "none" }, attrs: { colspan: "1" } },
                  [_vm._v("出生日期： ")]
                ),
                _c(
                  "td",
                  {
                    staticStyle: { border: "none", "font-weight": "600" },
                    attrs: { colspan: "7" },
                  },
                  [_vm._v(_vm._s(_vm.form.birthday))]
                ),
              ]
            ),
            _c(
              "tr",
              { staticStyle: { "line-height": "25px", border: "none" } },
              [
                _c(
                  "td",
                  { staticStyle: { border: "none" }, attrs: { colspan: "1" } },
                  [_vm._v("与儿童关系： ")]
                ),
                _c(
                  "td",
                  {
                    staticStyle: { border: "none", "font-weight": "600" },
                    attrs: { colspan: "7" },
                  },
                  [_vm._v(_vm._s(_vm.form.relation))]
                ),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "table",
        {
          staticClass: "header",
          staticStyle: { "text-align": "center", "margin-top": "15px" },
          attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
        },
        [
          _c("tbody", [
            _vm._m(2),
            _vm._m(3),
            _c("tr", { staticStyle: { "line-height": "30px" } }, [
              _c("td", [_vm._v("品行问题得分")]),
              _c("td", [_vm._v(_vm._s(_vm.form.conduct))]),
              _c("td", [
                _vm._v(
                  "0~3分" +
                    _vm._s(
                      _vm.form.conductRange
                        ? "，<" + _vm.form.conductRange + "正常"
                        : ""
                    )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.form.conductResult))]),
            ]),
            _c("tr", { staticStyle: { "line-height": "30px" } }, [
              _c("td", [_vm._v("学习问题得分")]),
              _c("td", [_vm._v(_vm._s(_vm.form.study))]),
              _c("td", [
                _vm._v(
                  "0~3分" +
                    _vm._s(
                      _vm.form.studyRange
                        ? "，<" + _vm.form.studyRange + "正常"
                        : ""
                    )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.form.studyResult))]),
            ]),
            _c("tr", { staticStyle: { "line-height": "30px" } }, [
              _c("td", [_vm._v("心身问题得分")]),
              _c("td", [_vm._v(_vm._s(_vm.form.psychosoma))]),
              _c("td", [
                _vm._v(
                  "0~3分" +
                    _vm._s(
                      _vm.form.psychosomaRange
                        ? "，<" + _vm.form.psychosomaRange + "正常"
                        : ""
                    )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.form.psychosomaResult))]),
            ]),
            _c("tr", { staticStyle: { "line-height": "30px" } }, [
              _c("td", [_vm._v("冲动-多动得分")]),
              _c("td", [_vm._v(_vm._s(_vm.form.hyperactivity))]),
              _c("td", [
                _vm._v(
                  "0~3分" +
                    _vm._s(
                      _vm.form.hyperactivityRange
                        ? "，<" + _vm.form.hyperactivityRange + "正常"
                        : ""
                    )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.form.hyperactivityResult))]),
            ]),
            _c("tr", { staticStyle: { "line-height": "30px" } }, [
              _c("td", [_vm._v("焦虑得分")]),
              _c("td", [_vm._v(_vm._s(_vm.form.anxiety))]),
              _c("td", [
                _vm._v(
                  "0~3分" +
                    _vm._s(
                      _vm.form.anxietyRange
                        ? "，<" + _vm.form.anxietyRange + "正常"
                        : ""
                    )
                ),
              ]),
              _c("td", [_vm._v(_vm._s(_vm.form.anxietyResult))]),
            ]),
          ]),
        ]
      ),
      _c(
        "table",
        {
          staticStyle: { "text-align": "center", "margin-top": "15px" },
          attrs: { cellspacing: "2", cellpadding: "2", border: "3" },
        },
        [
          _c("tbody", [
            _vm._m(4),
            _vm._m(5),
            _c("tr", { staticStyle: { "line-height": "30px" } }, [
              _c(
                "td",
                { staticStyle: { width: "30px" }, attrs: { colspan: "2" } },
                [_vm._v("测评得分")]
              ),
              _c("td", { attrs: { colspan: "6" } }, [
                _vm._v(_vm._s(_vm.form.totalScore)),
              ]),
            ]),
            _c("tr", { staticStyle: { "line-height": "30px" } }, [
              _c(
                "td",
                { staticStyle: { width: "30px" }, attrs: { colspan: "2" } },
                [_vm._v("得分说明")]
              ),
              _c("td", { attrs: { colspan: "6" } }, [
                _vm._v(
                  "0~3分，<" + _vm._s(_vm.form.simpleSymptomRange) + "正常"
                ),
              ]),
            ]),
            _c("tr", { staticStyle: { "line-height": "30px" } }, [
              _c(
                "td",
                { staticStyle: { width: "30px" }, attrs: { colspan: "2" } },
                [_vm._v("测评结果")]
              ),
              _c(
                "td",
                {
                  staticStyle: {
                    "word-wrap": "break-word",
                    overflow: "auto",
                    "text-align": "left",
                    "flex-wrap": "wrap",
                    "justify-content": "flex-start",
                  },
                  attrs: { colspan: "6" },
                },
                [_vm._v(_vm._s(_vm.form.result))]
              ),
            ]),
          ]),
        ]
      ),
      _vm._m(6),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      { staticStyle: { "line-height": "25px", border: "none" } },
      [
        _c("td", { staticStyle: { border: "none" } }, [
          _vm._v("测评内容： Conners儿重多动症及相关行为量表"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "table",
      {
        staticClass: "container",
        staticStyle: {
          border: "none",
          "text-align": "center",
          "margin-top": "10px",
          "margin-bottom": "10px",
        },
        attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
      },
      [
        _c("tbody", [
          _c(
            "tr",
            {
              staticStyle: {
                "background-color": "#ddd",
                height: "5px",
                "line-height": "35px",
                "font-size": "18px",
                "font-weight": "600",
              },
            },
            [_c("td", [_c("p", [_vm._v("第一部分 受测试者基本信息")])])]
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      {
        staticStyle: {
          "background-color": "#ddd",
          height: "35px",
          "line-height": "35px",
        },
      },
      [
        _c(
          "td",
          {
            staticStyle: { "font-size": "18px", "font-weight": "600" },
            attrs: { colspan: "8" },
          },
          [_vm._v("第二部分 结果信息")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      {
        staticStyle: { "background-color": "#9e9e9e1f", "line-height": "35px" },
      },
      [
        _c("td", [_vm._v("类型")]),
        _c("td", [_vm._v("得分")]),
        _c("td", [_vm._v("参考分值")]),
        _c("td", [_vm._v("结论")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "tr",
      {
        staticStyle: {
          "background-color": "#ddd",
          height: "35px",
          "line-height": "35px",
        },
      },
      [
        _c(
          "td",
          {
            staticStyle: { "font-size": "18px", "font-weight": "600" },
            attrs: { colspan: "8" },
          },
          [_vm._v("第三部分 结论信息")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", { staticStyle: { "line-height": "30px" } }, [
      _c("td", { staticStyle: { width: "30px" }, attrs: { colspan: "2" } }, [
        _vm._v("结论类型"),
      ]),
      _c("td", { attrs: { colspan: "6" } }, [_vm._v("多动指数")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "table",
      {
        staticClass: "container",
        staticStyle: {
          border: "none",
          "text-align": "left",
          "font-size": "17px",
          "margin-top": "20px",
        },
        attrs: { cellspacing: "0", cellpadding: "0", border: "0" },
      },
      [
        _c("tbody", [
          _c("tr", { staticStyle: { border: "none" } }, [
            _c(
              "td",
              { staticStyle: { "text-indent": "2ch", border: "none" } },
              [
                _vm._v(
                  "Conners父母症状问卷适用于评估3~17岁儿童行为问题，可以对多动症儿童的诊断敏感，对情绪障碍也有辅助作用。作为筛查量表，量表结论仅供参考，如果测评有问题，建议找医疗机构的医生咨询或诊断。"
                ),
              ]
            ),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }